import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {InputTypeModel} from '../../../../types/control';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {DEVELOPER_URL} from '../../index';
import {useSelector} from 'react-redux';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: InputTypeModel) => item.id;

export const InputTypeListScreen = memo(function InputType() {
    const {t} = useLocalization();
    const inputTypeList = useSelector(state => state.control.inputTypeList);

    const [selected, setSelected] = useState<InputTypeModel>(null);

    const displayNameExtractor = useCallback((item: InputTypeModel, column: ColumnModel) => {
        return item[column.key] || '-';
    }, []);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('input_type_name'),
            key: 'name',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='developer' isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                backUrl={DEVELOPER_URL}
                className="camera-list-page">
                <SettingsList
                    columns={columns}
                    items={inputTypeList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selected}
                    onItemSelected={setSelected}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
